import React, { useEffect, useState } from 'react';
import Banner from '../Banner/Banner';
import SteakHouseSpecials from '../SteakHouseSpecials/SteakHouseSpecials';
import { Container } from 'react-bootstrap';
import Reviews from '../Reviews/Reviews';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import useAuth from '../../hooks/useAuth';

const Home = () => {
    const { userLoading, isLoading, setIsLoading } = useAuth();
    const [banners, setBanners] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [specials, setSpecials] = useState([]);


    useEffect(() => {
        if (!userLoading) {
            setIsLoading(true);
            fetch('https://gentle-tor-99938.herokuapp.com/home')
                .then(res => res.json())
                .then((data) => {
                    setBanners(data.banners)
                    setSpecials(data.specials)
                    setReviews(data.reviews)
                })
                .finally(() => setIsLoading(false))

        }
    }, [userLoading])


    return (
        <main>
            {
                (!isLoading && banners.length > 0 && specials.length > 0)
                    ?
                    <>
                        <Header></Header>
                        <Banner banners={banners}></Banner>
                        <div className="col-12 col-md-11 mx-auto ">
                            <SteakHouseSpecials
                                specials={specials}
                            ></SteakHouseSpecials>
                            <Reviews reviews={reviews}></Reviews>
                        </div>
                        <Footer></Footer>
                    </>
                    :
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
            }
        </main>
    );
};

export default Home;